import { Modal, Form, Input, Button } from "antd";
import ReactInputMask from "react-input-mask";

const ModalAdicionarContato = ({
  isModalAddNovoContato,
  setIsModalAddNovoContato,
  form,
  isLoading,
  onCadastrarContato, // função passada pelo componente pai
}) => {
  return (
    <Modal
      open={isModalAddNovoContato}
      title="Adicionar Novo Contato"
      onCancel={() => {
        setIsModalAddNovoContato(false);
        form.resetFields();
      }}
      footer={null}
      width="25%"
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          label="Nome"
          name="nome"
          rules={[{ required: true, message: "Digite o nome do contato" }]}
        >
          <Input placeholder="Ex: João Silva" />
        </Form.Item>

        <Form.Item
          label="E-mail"
          name="email"
          rules={[
            { required: true, message: "Digite o e-mail do contato" },
            { type: "email", message: "Digite um e-mail válido" },
          ]}
        >
          <Input placeholder="Ex: joao@email.com" />
        </Form.Item>

        <Form.Item
          label="Telefone"
          name="telefone"
          rules={[{ required: true, message: "Digite o telefone do contato" }]}
        >
          <ReactInputMask mask="(99) 99999-9999" maskChar={null}>
            {(inputProps) => <Input {...inputProps} placeholder="Ex: (11) 99999-9999" />}
          </ReactInputMask>
        </Form.Item>

        <Form.Item>
          <Button
            className="bg-blue"
            loading={isLoading}
            onClick={onCadastrarContato}
            block
          >
            Salvar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAdicionarContato;
